import { useAppStore } from '@/state/store';
import { formatLength } from '@/lib/utils/units';

function StatRow({ label, value }: { label: string; value: string | null }) {
  return (
    <div className="stat-row">
      <span className="stat-label">{label}</span>
      <span className={`stat-value${value === null ? ' is-empty' : ''}`}>{value ?? '—'}</span>
    </div>
  );
}

export function DetectedStats() {
  const model = useAppStore((s) => s.model);
  const displayUnit = useAppStore((s) => s.viewer.displayUnit);

  const m = model?.metrics ?? null;

  return (
    <div>
      <div className="sidebar-section-label">Detected Properties</div>
      <div className="stat-list">
        <StatRow label="Model Name" value={m ? m.modelName : null} />
        <StatRow label="Length" value={m ? formatLength(m.length, displayUnit) : null} />
        <StatRow label="Barrel Diameter" value={m ? formatLength(m.barrelDiameter, displayUnit) : null} />
        <StatRow label="Handle Diameter" value={m ? formatLength(m.handleDiameter, displayUnit) : null} />
        <StatRow label="Knob Diameter" value={m ? formatLength(m.knobDiameter, displayUnit) : null} />
        <StatRow label="Profile Points" value={m ? String(m.totalProfilePoints) : null} />
      </div>
    </div>
  );
}
